import React from "react"
import { CONTENT_TYPES, PAGES } from "@/constants"
import PreserveSearchParamsLink from "@/components/common/Links/PreserveSearchParamsLink"

const Link = ({ data, children }) => {
	const typename = data.__typename
	const slug = data.slug
	switch (data.__typename) {
		case CONTENT_TYPES.SINGLE_PAGE: {
			const finalSlug = slug === "home" ? "/" : `${PAGES.POLISH_RED_CROSS}/${slug}`
			return (
				<PreserveSearchParamsLink key={typename} href={finalSlug}>
					{children}
				</PreserveSearchParamsLink>
			)
		}
		case CONTENT_TYPES.NEWS:
			return (
				<PreserveSearchParamsLink key={typename} href={`/${PAGES.POLISH_RED_CROSS}/${PAGES.NEWS}/${slug}`}>
					{children}
				</PreserveSearchParamsLink>
			)
		default:
			return null
	}
}

export default Link
